import { defineMessages } from 'react-intl';

export default defineMessages({
  updateSuccess: {
    id: 'app.components.companyDomains.updateSuccess',
    defaultMessage: 'Domain successfully saved.',
  },
});
